<template>
  <div>
    <section class="section">
    
      <a v-bind:href="apiUrl"><font-awesome-icon icon="home" size="2x" /></a> 

      <div class="container">  
        <div class="box has-background-grey-lighter" >
  
  <h1 class="title is-3 has-text-centered has-text-info">Contact expedijob</h1>

    <!-- our signup form ===================== -->
    <form id="signup-form" @submit.prevent="processForm">
      <!-- name -->
      <div class="field">
        <label class="label">Votre nom</label>
        <input type="text" class="input" name="name" v-model="name">
      </div>

      <!-- email -->
      <div class="field">
        <label class="label">Votre email</label>
        <input type="email" class="input" name="email" v-model="email">
      </div>

      <!-- subject -->
      <div class="field">
        <label class="label">Sujet</label>
        <input type="text" class="input" name="subject" v-model="subject">
      </div>

      <!-- text area -->
      <div class="field">
      <label class="label">Message</label>
        <textarea class="textarea" v-model="messbody"></textarea>
      </div>

      <!-- submit button -->
      <div class="field has-text-right">
        <button type="submit" class="button is-primary">Envoyer un message</button>
      </div>
    </form>

       </div>
      </div>
    </section>

    <footer class="footer">
        <nav class="level">

          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/blog/mainpage'">Blog</a> 
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/apropos'">A propos</a> 
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/mentionlegale'">Mentions légales</a> 
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/contact'">Contact</a> 
            </div>
          </div>
        </nav>  
    </footer>
  </div>    
</template>

<script>
import axios from 'axios'
export default {
    data () {
            return {
              name: null,
              email: null,
              subject: null,
              messbody: null,
              retourmessage: '',
              apiUrl : ''
            }
    }, 
    methods: {
      sendMessage(payload) {
        var api_url = this.apiUrl;
        api_url += '/sendmes';
        axios.post(api_url, payload)
          .then(response => {
          this.retourmessage = response.data.messageretour
          })
          .catch((error) => {
            console.log(error);
          });
      }, 
      processForm () {
        if (!this.name || !this.email || !this.subject || !this.messbody) {
          alert("Merci de compléter tous les champs");
        } else {
          const payload = {
            name: this.name,
            subject: this.subject,
            messbody: this.messbody,
            email: this.email
          };
          this.sendMessage(payload);
          alert("Message envoyé");
        }
      }
    }, 
    created () {
      this.apiUrl = process.env.API_URL;
    } 
  }
</script>





// WEBPACK FOOTER //
// src/components/Contact.vue